import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  formsTitle: {
    id: 'formBuilder.list.title',
    defaultMessage: 'Form Builder',
  },
  createTitle: {
    id: 'formBuilder.create',
    defaultMessage: 'Add New Form',
  },
  filterPlaceholder: {
    id: 'formBuilder.placeholder.filter',
    defaultMessage: 'Search or Add Filters',
  },
  filter: {
    name: {
      id: 'formBuilder.filter.name',
      defaultMessage: 'Form Name',
    },
    pubId: {
      id: 'formBuilder.filter.pubId',
      defaultMessage: 'Form ID',
    },
    tag: {
      id: 'formBuilder.filter.tag',
      defaultMessage: 'Tag Name',
    },
  },
  btn: {
    create: {
      id: 'formBuilder.btn.create',
      defaultMessage: 'Create',
    },
    update: {
      id: 'formBuilder.btn.update',
      defaultMessage: 'Update',
    },
    cancel: {
      id: 'formBuilder.btn.cancel',
      defaultMessage: 'Cancel',
    },
    delete: {
      id: 'formBuilder.btn.delete',
      defaultMessage: 'Delete',
    },
    return: {
      id: 'formBuilder.btn.return',
      defaultMessage: 'Return',
    },
  },
  error: {
    delete: {
      id: 'formBuilder.error.delete',
      defaultMessage:
        'This form cannot be deleted as this form is still assigned to some service(s) and/or biller(s)',
    },
    input: {
      formName: {
        id: 'formBuilder.error.input.formName',
        defaultMessage: 'Please input name',
      },
      formNameMax: {
        id: 'formBuilder.error.input.formNameMax',
        defaultMessage: 'Max name is 60 characters',
      },
      formDescription: {
        id: 'formBuilder.error.input.formDescription',
        defaultMessage: 'Max description is 120 characters',
      },
      formTags: {
        id: 'formBuilder.error.input.formTag',
        defaultMessage: 'Please select a tag',
      },
    },
  },
  confirmation: {
    title: {
      id: 'formBuilder.confirmation.title',
      defaultMessage: 'Confirmation',
    },
    delete: {
      id: 'formBuilder.confirmation.delete',
      defaultMessage: 'Are you sure want to delete {title} form?',
    },
  },
  label: {
    filter: {
      id: 'formBuilder.label.filter',
      defaultMessage: 'Add Filters',
    },
    formName: {
      id: 'formBuilder.label.formName',
      defaultMessage: 'Form Name',
    },
    formDescription: {
      id: 'formBuilder.label.formDescription',
      defaultMessage: 'Form Description',
    },
    formTags: {
      id: 'formBuilder.label.formTag',
      defaultMessage: 'Form Tags',
    },
  },
  placeholder: {
    formName: {
      id: 'formBuilder.placeholder.formName',
      defaultMessage: 'Enter your form name',
    },
    formDescription: {
      id: 'formBuilder.placeholder.formDescription',
      defaultMessage: 'Describe a little about your form',
    },
    formTags: {
      id: 'formBuilder.placeholder.formTag',
      defaultMessage: 'Choose form tag',
    },
  },
});
